/**
 * `abstractFormulaVisitor` is an abstract class
 * exposing the public API of the concrete visitors
 * in order to visit the formula nodes.
 */
export default class AbstractFormulaVisitor {
	visit(node) {
		return node.accept(this);
	}

	visitAll(aCollection) {
		return aCollection.map(function (each) {
			return this.visit(each);
		});
	}

	visitAbstractNode(_node) {
		throw new Error("Subclass responsibility");
	}

	visitBinaryOperatorNode(node) {
		return this.visitAbstractNode(node);
	}

	visitAdditionNode(node) {
		return this.visitBinaryOperatorNode(node);
	}

	visitSubtractionNode(node) {
		return this.visitBinaryOperatorNode(node);
	}

	visitMultiplicationNode(node) {
		return this.visitBinaryOperatorNode(node);
	}

	visitDivisionNode(node) {
		return this.visitBinaryOperatorNode(node);
	}

	visitSumNode(node) {
		return this.visitAbstractNode(node);
	}

	visitPeriodValueFormulaNode(node) {
		return this.visitWrapperNode(node);
	}

	visitComponentNode(node) {
		return this.visitWrapperNode(node);
	}

	visitConstantNode(node) {
		return this.visitAbstractNode(node);
	}

	visitDataNode(node) {
		return this.visitAbstractNode(node);
	}

	visitKeyFigureNode(node) {
		return this.visitAbstractNode(node);
	}

	visitNaNode(node) {
		return this.visitAbstractNode(node);
	}

	visitWrapperNode(node) {
		return this.visitAbstractNode(node);
	}

	visitNegatedNode(node) {
		return this.visitWrapperNode(node);
	}

	visitPreviousPeriodNode(node) {
		return this.visitWrapperNode(node);
	}

	visitPreviousYearNode(node) {
		return this.visitWrapperNode(node);
	}

	visitBalanceNode(node) {
		return this.visitPeriodValueFormulaNode(node);
	}

	visitChangeNode(node) {
		return this.visitPeriodValueFormulaNode(node);
	}

	visitClosingBalanceNode(node) {
		return this.visitPeriodValueFormulaNode(node);
	}

	visitOpeningBalanceNode(node) {
		return this.visitPeriodValueFormulaNode(node);
	}

	visitYearOpeningBalanceNode(node) {
		return this.visitPeriodValueFormulaNode(node);
	}

	visitOrNode(node) {
		return this.visitWrapperNode(node);
	}

	visitAccountNode(node) {
		return this.visitAbstractNode(node);
	}

	visitDimensionNode(node) {
		return this.visitWrapperNode(node);
	}

	visitPeriodShiftFormulaNode(node) {
		return this.visitWrapperNode(node);
	}

	visitPeriodChangeFormulaNode(node) {
		return this.visitWrapperNode(node);
	}

	visitPeriodRollingFormulaNode(node) {
		return this.visitWrapperNode(node);
	}

	visitReportReferenceNode(node) {
		return this.visitAbstractNode(node);
	}
}
